const FEATURE_APPS_HOST = process.env.FEATURE_APPS_HOST || '';
const BASE_DOMAIN = process.env.BASE_DOMAIN || 'oasis.synchronoss.com';
const ENTRY_JS = process.env.ENTRY_JS || 'remote.js';
/**
 * Create URL from known facts of a Feature App.
 * Name and Version are minimal requirements
 */
const constructUrl = ({ appName, baseDomain = BASE_DOMAIN, version, entryPoint = ENTRY_JS, }) => {
    // Replace camelCaseName with dashed-name
    const dashedAppName = appName.replace(/[A-Z]/g, (m) => '-' + m.toLowerCase());
    return `https://${dashedAppName}.${baseDomain}/${version}/${entryPoint}`;
};
/**
 * Check that the Feature App URL contains the necessary bits.
 * Auto-fix the URL if possible.
 * Prepend host of feature apps if configured
 * @param url Address URL
 * @param fasHost pre-configured host for Feature Apps or empty string
 */
const autoFixFeatureAppUrl = (url, fasHost = FEATURE_APPS_HOST) => {
    /**
     * Find GET variables and save them. They will be appended to the end after sanitation.
     */
    const GET_PARAMS_REGEX = /\?.*/;
    // Initialize params as empty
    let getParams = '';
    const getParamsFromURL = url.match(GET_PARAMS_REGEX);
    if (!!getParamsFromURL) {
        getParams = getParamsFromURL[0];
        // Remove any GET params to avoid conflicts with appending remote js
        url = url.replace(GET_PARAMS_REGEX, '');
    }
    /**
     * This next part will check if remote JS entry is set
     */
    // Checks that a URL ends with a JS file
    const CHECK_JS_REMOTE = /.[\.\w]+\.js$/;
    if (!url.match(CHECK_JS_REMOTE)) {
        // This URL doesn't end with `.js`.
        // Fixing it with certainty is impossible, but we'll assume that `remote.js` is missing
        // Note: this will not work well with GET params
        url = `${url}/${ENTRY_JS}`;
    }
    // Stitch GET params back
    url = `${fasHost}${url}${getParams}`;
    // Replace double slashes
    url = url.replace(/(\w)\/{2,}/gi, '$1/');
    return url;
};
/**
 * Get name and version from the feature app url
 * @param url Feature App URL
 */
const getFeatureAppUrlParts = (url) => {
    /**
     * Identify feature app parts from the URL
     * For example:
     *    URL: "https://my-feature-app.oasis.synchronoss.com/1.0.0/remote.js"
     *    Feature app name is group 3 - "oasis-feature-app-user-menu"
     *    Feature app version is group 4 - "3"
     */
    const FEATURE_APP_FROM_URL_REGEXP = /(http[s]?:\/\/)?([^\/\s]+\/)([^\/\s]+)\/([^\/\s]+)(.*)/;
    const APP_NAME_FROM_DOMAIN_REGEXP = /^([\w-]+)./;
    const urlParts = url.match(FEATURE_APP_FROM_URL_REGEXP);
    if (!urlParts) {
        return {
            name: null,
            version: null,
        };
    }
    const domainParts = urlParts[2].match(APP_NAME_FROM_DOMAIN_REGEXP);
    return {
        name: domainParts[1],
        version: urlParts[3],
    };
};
export { constructUrl, autoFixFeatureAppUrl, getFeatureAppUrlParts };
